/** Optional external profile / social links on a person archive. */

export const PROFILE_LINKS_TITLE = 'Profile links';
export const PROFILE_LINKS_SUBTITLE =
  'Optional links to their social pages or website — kept in your archive, not a public feed.';

export const PROFILE_LINKS_PRIVACY_NOTE =
  'These links stay in your archive for this profile. They are not verified, not auto-published, and remain private until you choose to share this archive.';

export const PROFILE_PLATFORMS = [
  { id: 'instagram', label: 'Instagram' },
  { id: 'tiktok', label: 'TikTok' },
  { id: 'facebook', label: 'Facebook' },
  { id: 'youtube', label: 'YouTube' },
  { id: 'linkedin', label: 'LinkedIn' },
  { id: 'website', label: 'Website' },
  { id: 'other', label: 'Other link' },
];

export function profilePlatformLabel(platformId) {
  return PROFILE_PLATFORMS.find((p) => p.id === platformId)?.label || 'Link';
}

export function blankProfileLink(platform = 'website') {
  return {
    id: typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `tmp-${Date.now()}`,
    platform,
    label: '',
    url: '',
    note: '',
  };
}

export function normalizeProfileLinkDraft(raw) {
  const url = (raw.url || '').trim();
  if (!url || !/^https?:\/\//i.test(url)) return null;
  const platform = PROFILE_PLATFORMS.some((p) => p.id === raw.platform) ? raw.platform : 'other';
  const label = (raw.label || '').trim();
  const note = (raw.note || '').trim();
  const entry = {
    id: raw.id || blankProfileLink(platform).id,
    platform,
    url,
  };
  if (label) entry.label = label;
  if (note) entry.note = note;
  return entry;
}

export function profileLinkDisplayLabel(link) {
  return (link.label || '').trim() || profilePlatformLabel(link.platform);
}
